export enum UnifiedSigninStatus {
  MFA_REQUIRED = 'MFA_REQUIRED',
  OK = 'OK',
  ERROR = 'ERROR',
  ERR_USER_NOT_FOUND ="ERR_USER_NOT_FOUND",
  ERR_TOO_MANY_CRED ="ERR_TOO_MANY_CRED",
  ERR_INACTIVE_ACC ="ERR_INACTIVE_ACC"
}

export interface UnifiedSigninResponse {
  status: UnifiedSigninStatus;
  token?: string;
  code?: string;
}
